export default {
  emptyStateHeader: 'No pending teammates',
};
